<template>
  <v-data-table
    :headers="headers"
    :items="appointments"
    must-sort
    disable-initial-sort
    hide-actions
    no-data-text="Нет записей в этот день"
    id="desctopTable"
  >
    <template v-slot:items="props">
      <tr :class="props.item.visitStatus">
        <td class="text-xs-left">{{ props.item.clientName }}</td>
        <td class="text-xs-left">{{ props.item.clientPhone }}</td>
        <td class="text-xs-left">
          <span v-for="item of props.item.services" :key="item.id">
            {{ item.title }}
            <br>
          </span>
        </td>

        <td class="text-xs-left">
          <v-avatar size="" color="grey lighten-4">
            <img style="object-fit: cover;" :src="props.item.staffImg" alt="avatar" :title="props.item.staffName">
          </v-avatar>
        </td>
        <td class="text-xs-center">{{ props.item.visitTime }}</td>
        <td class="text-xs-left"><a v-bind:href="'http://' + props.item.shortLink" target="_blank">{{ props.item.shortLink }}</a></td>
        <td class="text-xs-center">
          <v-btn v-if="!props.item.isSmsSent" color="#4169E1" style="color:white" @click="sendSms(props.item.yclientsId)" title="Отправить">
            <v-icon>send</v-icon>
          </v-btn>
          <v-btn v-if="props.item.isSmsSent" color="#4169E1" style="color:white" @click="sendSms(props.item.yclientsId)" disabled title="Отправлено">
            <v-icon>send</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<style>
  #desctopTable .v-avatar img {
    height: 35px;
    width: 35px;
    border: 1px solid #333;
  }
  #desctopTable .waiting {
    background-color: rgba(255, 209, 102, 0.5)
  }
  #desctopTable .confirmed {
    background-color: rgba(51, 221, 177, 0.5)
  }
  #desctopTable .canceled {
    background-color: rgba(239, 71, 111, 0.5)
  }
  #desctopTable .edited {
    background-color: rgba(128, 128, 128, 0.5)
  }
  #desctopTable .theme--light.v-table tbody .waiting:hover:not(.v-datatable__expand-row) {
    background: rgba(255, 209, 102, 0.5)
  }
  #desctopTable .theme--light.v-table tbody .confirmed:hover:not(.v-datatable__expand-row) {
    background: rgba(51, 221, 177, 0.5)
  }
  #desctopTable .theme--light.v-table tbody .canceled:hover:not(.v-datatable__expand-row) {
    background: rgba(239, 71, 111, 0.5)
  }
  #desctopTable .theme--light.v-table tbody .edited:hover:not(.v-datatable__expand-row) {
    background: rgba(128, 128, 128, 0.5)
  }
</style>

<script>
import SyncDataLogic from './SyncDataLogic'

export default {
  extends: SyncDataLogic
}
</script>
